<template>
  <v-container fluid grid-list-lg>
    <v-layout rows wrap>
      <v-flex xs12 sm6 lg4 order-xs3 order-sm1 order-lg1>
        <v-layout row wrap>
          <v-flex>
            <v-card>
              <v-card-title class="profile-header">
                <h3>Profile</h3>
                <v-btn color="primary" v-if="!otpEnabled && environment === 'development' && hasPermission('superuser')" @click="enableOTP">Enable 2FA</v-btn>
                <v-btn color="primary" v-if="otpEnabled" @click="disableOTP">Disable 2FA</v-btn>
              </v-card-title>
              <v-card-text>
                <table class="centered">
                  <tbody>
                    <tr>
                      <th text-xs-right class="primary--text table-align-right">Connected:</th>
                      <td>{{this.connected}}</td>
                    </tr>
                    <tr>
                      <th text-xs-right class="primary--text table-align-right">Name:</th>
                      <td>{{myProfile.name}}</td>
                    </tr>
                    <tr>
                      <th text-xs-right class="primary--text table-align-right">Email:</th>
                      <td>{{myProfile.email}}</td>
                    </tr>
                    <tr>
                      <th text-xs-right class="primary--text table-align-right">Timezone:</th>
                      <td>{{myProfile.timezone}}</td>
                    </tr>
                    <tr>
                      <th text-xs-right class="primary--text table-align-right">Position:</th>
                      <td>{{myProfile.position}}</td>
                    </tr>
                    <tr v-if="!(terminalsCardCanCharge.length > 1 || terminalsACHCanCharge.length > 1)">
                      <th text-xs-right class="primary--text table-align-right">Account:</th>
                      <td>{{accountNameSelected}}</td>
                    </tr>
                    <tr>
                      <th text-xs-right class="primary--text table-align-right">Created:</th>
                      <td>{{timeAgo(myProfile.created, true)}}</td>
                    </tr>
                    <tr>
                      <th text-xs-right class="primary--text table-align-right">Password Changed:</th>
                      <td>{{timeAgo(myProfile.password_last_changed, true)}}</td>
                    </tr>
                    <tr>
                      <th text-xs-right class="primary--text table-align-right">Password Expires:</th>
                      <td>{{timeAgo(myProfile.password_last_changed, true)}}</td>
                    </tr>
                    <tr v-if="terminalsCardCanCharge.length > 1">
                      <th text-xs-right class="primary--text">Default Card Terminal</th>
                      <td>
                        <v-autocomplete
                          v-model="defaultCardTerminalId"
                          :items="cardTerminalList"
                          item-text="name"
                          item-value="terminal_id"
                          @change="handleTerminalChange('card')"
                          :error-messages="error.card"
                          :loading="loading.card"
                          single-line
                          :success-messages="success.card"
                        />
                      </td>
                    </tr>
                    <tr v-if="terminalsACHCanCharge.length > 1">
                      <th text-xs-right class="primary--text">Default ACH Terminal</th>
                      <td>
                        <v-autocomplete
                          v-model="defaultAchTerminalId"
                          :items="achTerminalList"
                          item-text="name"
                          item-value="terminal_id"
                          @change="handleTerminalChange('ach')"
                          :error-messages="error.ach"
                          :loading="loading.ach"
                          single-line
                          :success-messages="success.ach"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-card-text>
              <v-card-actions class="pr-4 pb-3">
                <v-spacer></v-spacer>
                <v-btn color="primary" to="change_password">Change Password</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex v-if="accountList.length === 1">
            <v-card>
              <v-card-title><h3>Account</h3></v-card-title>
              <v-card-text>
                <div class="primary--text">{{accountSelected.name}}</div>

                <template v-if="accountSelected.logo">
                  <v-img contain max-height="100px" max-width="200px" position="left, center" :src="imageUrl + '/' + accountSelected.logo"/>
                </template>

                <div>{{accountSelected.street_1}}</div>
                <div>{{accountSelected.street_2}}</div>
                <div>
                  {{accountSelected.city}},
                  {{accountSelected.state}}
                  {{accountSelected.zip}}
                </div>
                <div v-if="hasPermission('can_manage_account')">
                  <v-text-field
                    label="Manager Password"
                    v-model="accountSelected.manager_password"
                    box
                    hide-details
                  />
                </div>
                <div v-if="hasPermission('can_manage_account')">
                  <v-text-field
                    label="Manager Password"
                    v-model="accountSelected.manager_password"
                    @keypress.enter="show"
                  >
                    <template v-slot:append>
                      <v-btn
                        depressed
                        tile
                        color="primary"
                        class="ma-0"
                        @click="show"
                      >
                        save
                      </v-btn>
                    </template>
                  </v-text-field>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12 sm6 lg8 order-xs2 order-sm2 order-lg2 v-if="hasPermission('can_use_billings') || hasPermission('can_use_hpp') || hasPermission('can_waive_card_fees') || hasPermission('can_waive_health_card_fees') || hasAccountPermission('can_view_funding')">
        <v-layout row wrap>
          <v-flex xs12 lg6 v-if="hasPermission('can_use_billings') || hasPermission('can_waive_card_fees') || hasPermission('can_waive_health_card_fees') || hasAccountPermission('can_view_funding')">
            <v-card>
              <v-card-title><h3>Help</h3></v-card-title>
              <v-card-text>
                <v-btn color="primary" to="/credit?waive=1" v-if="hasPermission('can_waive_card_fees')">
                  For use with waive fee&nbsp;<b>ONLY</b>
                  <v-divider vertical class="ml-3 mr-2" v-if="hasPermission('has_inline_help')"></v-divider>
                  <Lightbulb color="primary--text">
                    <template v-slot:message>
                      <span>For Waiving the fee on a customer.</span>
                    </template>
                  </Lightbulb>
                </v-btn>

                <v-btn color="primary" to="/credit?waive=2" v-if="hasPermission('can_waive_health_card_fees')">
                  For Fixed Insurance Payment
                  <v-divider vertical class="ml-3 mr-2" v-if="hasPermission('has_inline_help')"></v-divider>
                  <Lightbulb color="primary--text">
                    <template v-slot:message>
                      <span>Used for fixed insurance payment cards.</span>
                    </template>
                  </Lightbulb>
                </v-btn>

                <v-btn color="primary" href="/static/settlement_report_example.png" target="_blank" v-if="environment === 'development' && hasPermission('has_inline_help')">Settlement Report Example</v-btn>

                <v-btn color="primary" to="/billings" v-if="hasPermission('can_use_billings')">
                  Billings
                  <v-divider vertical class="ml-3 mr-2" v-if="hasPermission('has_inline_help')"></v-divider>
                  <Lightbulb color="primary--text">
                    <template v-slot:message>
                      <span>Customer billings: billing info and tokens.</span>
                    </template>
                  </Lightbulb>
                </v-btn>

                <v-btn color="primary" to="/paynetworx/funding" v-if="hasAccountPermission('can_view_funding')">
                  Paynetworx Settlement & Funding Dashboard
                </v-btn>
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex xs12 lg6 v-if="hasPermission('can_use_hpp')">
            <v-card>
              <v-card-title><h3>Links</h3></v-card-title>
              <v-card-text>
                <v-layout column>
                  <v-flex v-if="(environment === 'development' && accountSelected.account_id === 5) || accountSelected.account_id === 1507">
                    <h2 class="primary--text">HPP Links</h2>
                    <ul>
                      <li>
                        <a href="https://payments.paynetworx.com/?token=22eQ9O0xwSoUpsc0av9RLxnMfvm&amount=6000">$60 antibody test</a>
                      </li>
                      <li>
                        <a href="https://payments.paynetworx.com/?token=22eQ9O0xwSoUpsc0av9RLxnMfvm&amount=10000">$100 antigen test</a>
                      </li>
                      <li>
                        <a href="https://payments.paynetworx.com/?token=22eQ9O0xwSoUpsc0av9RLxnMfvm&amount=17500">$175 1 hour antigen test or 24 hour PCR</a>
                      </li>
                      <li>
                        <a href="https://payments.paynetworx.com/?token=22eQ9O0xwSoUpsc0av9RLxnMfvm&amount=25500">$255 eye drop</a>
                      </li>
                      <li>
                        <a href="https://payments.paynetworx.com/?token=22eQ9O0xwSoUpsc0av9RLxnMfvm&amount=30000">$300 3 hour PCR</a>
                      </li>
                    </ul>
                  </v-flex>

                  <v-flex>
                    <v-layout>
                      <v-flex>
                        <h2 class="primary--text">Hosted Payment Link</h2>
                      </v-flex>
                      <v-flex shrink>
                        <ExampleHPPLinkSite></ExampleHPPLinkSite>
                      </v-flex>
                    </v-layout>
                    <span class="caption grey--text">Please select at least one terminal to create, copy, or regenerate your hosted payment link.</span>

                    <v-form ref="hppForm" v-model="hppFormValid">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-autocomplete
                          v-if="hasPermission('superuser')"
                          v-model="hppSelectedAccountId"
                          :items="myProfile.accounts"
                          item-text="name"
                          item-value="account_id"
                          label="Select Account"
                          :loading="hppLoadingTerminals"
                          @change="onHppAccountChange"
                        />
                        <v-checkbox
                          v-if="showCheckbox"
                          v-model="useTwoTerminals"
                          color="primary"
                          label="Use Separate Terminals"
                          :disabled="hasPermission('superuser') && !hppSelectedAccountId"
                        ></v-checkbox>
                        <v-autocomplete
                          v-if="!useTwoTerminals"
                          class="terminal-select"
                          v-model="tokenValues.selectedTerminalId"
                          :items="availableTerminals"
                          item-text="name"
                          item-value="id"
                          label="Terminal"
                          :disabled="hasPermission('superuser') && !hppSelectedAccountId"
                        />
                        <v-autocomplete
                          v-if="useTwoTerminals && achTerminals.length"
                          class="double-terminal-select"
                          v-model="tokenValues.selectedACHTerminalId"
                          :items="achTerminals"
                          item-text="name"
                          item-value="id"
                          :label="tokenValues.selectedCardTerminalId ? 'ACH Terminal' : 'ACH Terminal *'"
                          :disabled="hasPermission('superuser') && !hppSelectedAccountId"
                          clearable
                        />
                        <v-autocomplete
                          v-if="useTwoTerminals && cardTerminals.length"
                          class="double-terminal-select"
                          v-model="tokenValues.selectedCardTerminalId"
                          :items="cardTerminals"
                          item-text="name"
                          item-value="id"
                          :label="tokenValues.selectedACHTerminalId ? 'Card Terminal' : 'Card Terminal *'"
                          :disabled="hasPermission('superuser') && !hppSelectedAccountId"
                          clearable
                        />
                      </v-flex>

                      <v-flex xs12>
                        <v-divider class="my-2"></v-divider>
                        <v-checkbox
                          v-model="restrictPaymentTypes"
                          color="primary"
                          label="Restrict Available Payment Methods"
                          hide-details
                          class="mt-0"
                        ></v-checkbox>
                      </v-flex>

                      <template v-if="restrictPaymentTypes">
                        <v-flex xs12>
                          <v-checkbox
                            v-if="terminalSupportsCard"
                            v-model="allowCard"
                            color="primary"
                            label="Allow Card"
                            hide-details
                            class="mt-0"
                          ></v-checkbox>
                          <v-checkbox
                            v-if="terminalSupportsACH"
                            v-model="allowACH"
                            color="primary"
                            label="Allow ACH"
                            hide-details
                            class="mt-0"
                          ></v-checkbox>
                          <span v-if="!terminalSupportsCard && !terminalSupportsACH" class="caption grey--text">Select a terminal above to configure payment methods.</span>
                        </v-flex>
                      </template>

                      <v-flex xs12>
                        <v-divider class="my-2"></v-divider>
                        <v-checkbox
                          v-model="consentEnabled"
                          color="primary"
                          label="Require Terms & Conditions Consent"
                          hide-details
                          class="mt-0"
                        ></v-checkbox>
                      </v-flex>

                      <template v-if="consentEnabled">
                        <v-flex xs12>
                          <v-checkbox
                            v-model="consentRequired"
                            color="primary"
                            label="Block payment until consent is accepted"
                            hide-details
                            class="mt-0"
                          ></v-checkbox>
                        </v-flex>

                        <v-flex xs12>
                          <v-text-field
                            v-model="consentLabel"
                            label="Consent Checkbox Label (HTML allowed)"
                            placeholder="I agree to the Terms and Conditions of this payment."
                          ></v-text-field>
                        </v-flex>

                        <v-flex xs12>
                          <v-checkbox
                            v-model="consentModalEnabled"
                            color="primary"
                            label="Show Terms in a Modal Dialog"
                            hide-details
                            class="mt-0"
                          ></v-checkbox>
                        </v-flex>

                        <template v-if="consentModalEnabled">
                          <v-flex xs12>
                            <v-text-field
                              v-model="consentModalTitle"
                              label="Modal Title"
                              placeholder="Terms and Conditions"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12>
                            <v-textarea
                              v-model="consentModalContent"
                              label="Modal Content (HTML allowed)"
                              placeholder="<p>By proceeding with this payment...</p>"
                              rows="3"
                              auto-grow
                            ></v-textarea>
                          </v-flex>
                        </template>
                      </template>

                      <v-flex xs12 v-if="generatedUrl">
                        <span block class="generated-url">{{generatedUrl}}</span>
                      </v-flex>

                      <v-flex xs12 v-if="generatedUrlError">
                        <span block class="generated-url">{{generatedUrlError}}</span>
                      </v-flex>

                      <v-flex xs6>
                        <v-btn block :disabled="!tokenValues.selectedTerminalId && !tokenValues.selectedACHTerminalId && !tokenValues.selectedCardTerminalId" color="primary" @click="getURL">
                          <v-icon left small>fa-link</v-icon>{{ generatedToken ? 'Show Link' : 'Create Link' }}
                        </v-btn>
                      </v-flex>

                      <v-flex xs6>
                        <v-btn block :disabled="!generatedUrl" color="primary" @click="copyURL">
                          <v-icon left small>fa-copy</v-icon>Copy Link
                        </v-btn>
                      </v-flex>

                      <v-flex xs6 v-if="hasPermission('superuser')">
                        <v-btn block :disabled="!generatedToken" color="primary" @click="updateURL">
                          <v-icon left small>fa-save</v-icon>Update Link
                        </v-btn>
                      </v-flex>

                      <v-flex xs6 v-if="hasPermission('superuser')">
                        <v-btn block :disabled="!tokenValues.selectedTerminalId && !tokenValues.selectedACHTerminalId && !tokenValues.selectedCardTerminalId" color="primary" @click="regenerateURL">
                          <v-icon left small>fa-refresh</v-icon>Regenerate Link
                        </v-btn>
                        <div class="caption grey--text text-xs-center mt-1">Deactivates current token and generates a new one</div>
                      </v-flex>
                    </v-layout>
                    </v-form>
                  </v-flex>

                  <v-flex v-if="(environment === 'development' && (accountSelected.account_id === 5 || accountSelected.account_id === 70 || accountSelected.account_id === 270)) || accountSelected.id === 12 || accountSelected.parent_account_id === 12">
                    <v-layout>
                      <v-flex>
                        <h2 class="primary--text">Invoice Link</h2>
                        <span v-if="(environment === 'development' && (accountSelected.account_id === 5 || accountSelected.account_id === 70 || accountSelected.account_id === 270)) || accountSelected.id === 12 || accountSelected.parent_account_id === 12">{{ accountSelected.parent_account_id }}</span>
                      </v-flex>
                      <v-flex shrink>
                        <ExampleInvoice></ExampleInvoice>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-checkbox
                          v-if="showCheckbox"
                          v-model="useTwoTerminals"
                          color="primary"
                          label="Use Separate Terminals"
                        ></v-checkbox>
                        <v-autocomplete
                          v-if="!useTwoTerminals"
                          class="terminal-select"
                          v-model="tokenValues.selectedTerminalId"
                          :items="availableTerminals"
                          item-text="name"
                          item-value="id"
                          label="Terminal"
                        />
                        <v-select
                          v-if="useTwoTerminals && achTerminals.length"
                          class="double-terminal-select"
                          v-model="tokenValues.selectedACHTerminalId"
                          :items="achTerminals"
                          item-text="name"
                          item-value="id"
                          label="ACH Terminal"
                          clearable
                        />
                        <v-select
                          v-if="useTwoTerminals && cardTerminals.length"
                          class="double-terminal-select"
                          v-model="tokenValues.selectedCardTerminalId"
                          :items="cardTerminals"
                          item-text="name"
                          item-value="id"
                          label="Card Terminal"
                          clearable
                        />
                      </v-flex>

                      <v-flex xs12 v-if="generatedUrl">
                        <span block class="generated-url">{{generatedUrl}}</span>
                      </v-flex>

                      <v-flex xs12 v-if="generatedUrlError">
                        <span block class="generated-url">{{generatedUrlError}}</span>
                      </v-flex>

                      <v-flex xs12 sm6>
                        <v-btn block :disabled="!tokenValues.selectedTerminalId && !tokenValues.selectedACHTerminalId && !tokenValues.selectedCardTerminalId" color="primary" @click="getURL">Create Link</v-btn>
                      </v-flex>

                      <v-flex xs12 sm6>
                        <v-btn block :disabled="!generatedUrl" color="primary" @click="copyURL">Copy Link</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex v-if="otpEnabled">
        <v-card>
          <v-card-title><h3>2FA Type</h3></v-card-title>
          <v-card-text>
            <v-radio-group v-model="otpEnabled">
              <v-radio label="SMS" value="0"></v-radio>
              <v-radio label="TOTP" value="1"></v-radio>
              <v-radio label="Push" value="0"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 sm6 lg4 class="text-xs-center" v-if="qrValue">
        <v-card>
          <qrcode-vue :value="qrValue" size="300" className="qrcode"></qrcode-vue>
          <v-form>
            <v-card-title>
              <h3>2FA Token</h3>
            </v-card-title>
            <v-card-text class="text-xs-center xs12 sm6 offset-sm3">
              <v-text-field prepend-icon="lock" name="otpToken" label="2FA Token" v-model="otpToken"/>
            </v-card-text>
            <v-card-actions>
              <v-btn primary large block @click="verifyOTP">Validate</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>

      <template v-if="environment === 'development' && hasPermission('superuser')">
        <v-flex xs12 sm6 lg4>
          <v-card>
            <v-card-title><h3>Permissions</h3></v-card-title>
            <v-card-text>
              <div>
                <vue-json-pretty :data="permissions"></vue-json-pretty>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 sm6 lg4>
          <v-card>
            <v-card-title><h3>Settings</h3></v-card-title>
            <v-card-text>
              <div>
                <vue-json-pretty :data="myProfile.custom"></vue-json-pretty>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </template>

    </v-layout>

    <v-snackbar bottom centered color="success" v-model="isLinkCopied">
      <v-layout row wrap align-center>
        <v-flex>
          <v-icon>fa-info-circle</v-icon>
        </v-flex>
        <v-flex subheading>
          Link copied to clipboard
        </v-flex>
      </v-layout>
    </v-snackbar>
  </v-container>
</template>

<script>
import ExampleHPPLinkSite from '@/components/help/ExampleHPPLinkSiteDialog'
import ExampleInvoice from '@/components/help/ExampleInvoiceDialog'
import Lightbulb from '@/components/help/Lightbulb'
import QrcodeVue from 'qrcode.vue'
import VueJsonPretty from '@/components/VueJsonPrettyWrapper'

import APIMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  components: {
    ExampleHPPLinkSite,
    ExampleInvoice,
    Lightbulb,
    QrcodeVue,
    VueJsonPretty
  },

  mixins: [
    APIMixin,
    AuthMixin,
    DisplayMixin,
    StoreMixin
  ],

  data: function () {
    return {
      loading: {
        'card': false,
        'ach': false
      },
      success: {
        'card': [],
        'ach': []
      },
      error: {
        'card': [],
        'ach': []
      },
      imageUrl: process.env.VUE_APP_IMAGE_URL,
      qrValue: false,
      otpEnabled: false,
      otpType: false,
      otpToken: '',
      availableTerminals: null,
      achTerminals: null,
      cardTerminals: null,
      useTwoTerminals: false,
      showCheckbox: false,
      restrictPaymentTypes: false,
      allowCard: true,
      allowACH: true,
      consentEnabled: false,
      consentRequired: false,
      consentLabel: '',
      consentModalEnabled: false,
      consentModalTitle: '',
      consentModalContent: '',
      tokenValues: {
        amount: undefined,
        method: undefined,
        name: undefined,
        billingName: undefined,
        email: undefined,
        phone: undefined,
        address1: undefined,
        address2: undefined,
        city: undefined,
        state: undefined,
        zip: undefined,
        customField1: undefined,
        customField2: undefined,
        customField3: undefined,
        selectedTerminalId: null,
        selectedACHTerminalId: null,
        selectedCardTerminalId: null
      },
      generatedUrl: '',
      generatedToken: null,
      generatedUrlError: '',
      hppFormValid: false,
      terminalError: '',
      isLinkCopied: false,
      managerPassword: '',
      cardTerminalsList: [{name: '- None -', terminal_id: 0}],
      achTerminalsList: [{name: '- None -', terminal_id: 0}],
      defaultCardTerminalId: null,
      defaultAchTerminalId: null,
      terminal: {},
      account: {},
      hppSelectedAccountId: null,
      hppLoadingTerminals: false
    }
  },

  async mounted () {
    if (this.myProfile.custom.hasOwnProperty('default_card_terminal_id')) {
      this.defaultCardTerminalId = this.myProfile.custom.default_card_terminal_id
    }
    if (this.myProfile.custom.hasOwnProperty('default_ach_terminal_id')) {
      this.defaultAchTerminalId = this.myProfile.custom.default_ach_terminal_id
    }

    const terminalArr = [...this.terminalsACHCanCharge, ...this.terminalsCardCanCharge]
    this.availableTerminals = terminalArr.filter((v, i, a) => a.findIndex(t => (t.code === v.code)) === i)
    if (this.availableTerminals.length === 1) {
      this.tokenValues.selectedTerminalId = this.availableTerminals[this.availableTerminals.length - 1].id
    }
    this.bothTerminals = this.availableTerminals.filter(terminal => {
      if (terminal.type[0] === '[') {
        return JSON.parse(terminal.type).some(item => item === 'ach') && JSON.parse(terminal.type).some(item => item !== 'ach')
      } else {
        return false
      }
    })
    this.achTerminals = [...this.availableTerminals.filter(terminal => {
      if (terminal.type === 'ach') {
        return true
      } else if (terminal.type[0] === '[') {
        return !JSON.parse(terminal.type).some(item => item !== 'ach')
      } else return false
    }), ...this.bothTerminals]
    this.cardTerminals = [...this.availableTerminals.filter(terminal => {
      if (terminal.type[0] === '[') {
        return !JSON.parse(terminal.type).some(item => item === 'ach')
      } else {
        return terminal.type !== 'ach'
      }
    }), ...this.bothTerminals]
    if (!this.bothTerminals.length) {
      this.useTwoTerminals = true
    } else if ((this.achTerminals.length - this.bothTerminals.length) > 0 || (this.cardTerminals.length - this.bothTerminals.length) > 0) {
      this.showCheckbox = true
    }
    if (this.bothTerminals.length === 1 && !this.useTwoTerminals) {
      this.tokenValues.selectedTerminalId = this.bothTerminals[0].id
    }

    await this.getURL()
  },

  watch: {
    'tokenValues.selectedTerminalId' () {
      this.generatedUrl = ''
      this.generatedToken = null
    },
    'tokenValues.selectedACHTerminalId' () {
      this.generatedUrl = ''
      this.generatedToken = null
    },
    'tokenValues.selectedCardTerminalId' () {
      this.generatedUrl = ''
      this.generatedToken = null
    },
    restrictPaymentTypes () {
      this.generatedUrl = ''
    },
    allowCard () {
      this.generatedUrl = ''
    },
    allowACH () {
      this.generatedUrl = ''
    },
    consentEnabled () {
      this.generatedUrl = ''
    },
    consentRequired () {
      this.generatedUrl = ''
    },
    consentLabel () {
      this.generatedUrl = ''
    },
    consentModalEnabled () {
      this.generatedUrl = ''
    },
    consentModalTitle () {
      this.generatedUrl = ''
    },
    consentModalContent () {
      this.generatedUrl = ''
    }
  },

  computed: {
    environment () {
      return process.env.NODE_ENV
    },
    cardTerminalList: function () {
      let terminals = [
        {terminal_id: 0, name: '- None -'}
      ]
      return terminals.concat(this.terminalsCardCanCharge)
    },
    achTerminalList: function () {
      let terminals = [
        {terminal_id: 0, name: '- None -'}
      ]
      return terminals.concat(this.terminalsACHCanCharge)
    },
    terminalSupportsCard () {
      if (this.useTwoTerminals) return !!this.tokenValues.selectedCardTerminalId
      if (!this.tokenValues.selectedTerminalId || !this.cardTerminals) return false
      return this.cardTerminals.some(t => t.id === this.tokenValues.selectedTerminalId)
    },
    terminalSupportsACH () {
      if (this.useTwoTerminals) return !!this.tokenValues.selectedACHTerminalId
      if (!this.tokenValues.selectedTerminalId || !this.achTerminals) return false
      return this.achTerminals.some(t => t.id === this.tokenValues.selectedTerminalId)
    }
  },

  methods: {
    waiveFeeRedirect (to, event) {
      let message = `Attention:
Clicking on this link will allow you to process a Government issued Pre-Paid Card or an Insurance Issued Pre-Paid Card where the amount is set on the card for an Individual or group of patients. This does not include FSA, HSA or any standard Debit, Credit or Savings Card. Are you sure you would like to proceed with the transaction?`

      if (confirm(message)) {
        this.$router.push(to)
      }
    },

    async enableOTP () {
      this.otpEnabled = true

      try {
        let result = await this.api({
          method: 'get',
          url: `/users/otp`
        })

        this.qrValue = result.data.secret.otpauth_url
      } catch (err) {
        console.log(err)
      }
    },

    async disableOTP () {
      try {
        await this.api({
          method: 'delete',
          url: `/users/otp`
        })

        this.otpEnabled = false
        this.otpType = false
      } catch (err) {
        console.log(err)
      }
    },

    async verifyOTP () {
      try {
        let result = await this.api({
          method: 'post',
          url: `/users/otp`,
          data: { otp_token: this.otpToken }
        })

        console.log('verityOTP result')
        console.log(result)
        this.otpEnabled = true
        this.otpType = 1
      } catch (err) {
        console.log(err)
      }
    },

    async handleTerminalChange (terminalType) {
      try {
        this.loading[terminalType] = true

        let options = {}

        if (terminalType === 'card') {
          options['default_card_terminal_id'] = this.defaultCardTerminalId
        }

        if (terminalType === 'ach') {
          options['default_ach_terminal_id'] = this.defaultAchTerminalId
        }

        if (Object.keys(options).length) {
          let result = await this.api({
            method: 'put',
            url: '/users/' + this.myProfile.email,
            data: { custom: options }
          })

          if (result.data.hasOwnProperty('error') && !result.data.error) {
            // update state
            if (terminalType === 'card' && options.hasOwnProperty('default_card_terminal_id')) {
              this.$store.commit('setDefaultCardTerminal', this.defaultCardTerminalId)
              this.success['card'] = ['Saved']
              setTimeout(() => {
                this.success['card'] = []
              }, '5000')
            }
            if (terminalType === 'ach' && options.hasOwnProperty('default_ach_terminal_id')) {
              this.$store.commit('setDefaultAchTerminal', this.defaultAchTerminalId)
              this.success['ach'] = ['Saved']
              setTimeout(() => {
                this.success['ach'] = []
              }, '5000')
            }
          } else {
            if (terminalType === 'card') {
              this.error['card'] = ['Problem Saving']
              setTimeout(() => {
                this.error['card'] = []
              }, '5000')
            }
            if (terminalType === 'ach') {
              this.error['ach'] = ['Problem Saving']
              setTimeout(() => {
                this.error['ach'] = []
              }, '5000')
            }
            throw new Error('Problem saving user')
          }
        }
      } catch (error) {
      } finally {
        this.loading[terminalType] = false
      }
    },

    copyURL () {
      if (this.generatedUrl && navigator && navigator.clipboard && navigator.clipboard.writeText) {
        this.isLinkCopied = true
        return navigator.clipboard.writeText(this.generatedUrl)
      }
    },

    hasAccountPermission (permission) {
      if (!this.myProfile || !this.myProfile.accounts) {
        return false
      }
      return this.myProfile.accounts.some(account => {
        return account.user_permissions && account.user_permissions[permission]
      })
    },

    async onHppAccountChange () {
      this.tokenValues.selectedTerminalId = null
      this.tokenValues.selectedACHTerminalId = null
      this.tokenValues.selectedCardTerminalId = null
      this.generatedUrl = ''
      this.generatedToken = null
      this.generatedUrlError = ''
      this.availableTerminals = []
      this.achTerminals = []
      this.cardTerminals = []
      this.useTwoTerminals = false
      this.showCheckbox = false

      if (!this.hppSelectedAccountId) return

      this.hppLoadingTerminals = true
      try {
        let result = await this.api({
          method: 'get',
          url: '/terminals',
          params: {
            filter: { account_id: this.hppSelectedAccountId, active: 1 },
            perPage: 999
          }
        })

        const terminals = (result.data.rows || []).filter(t => t.is_virtual === 1)

        const terminalArr = terminals.filter((v, i, a) => a.findIndex(t => t.code === v.code) === i)
        this.availableTerminals = terminalArr

        if (this.availableTerminals.length === 1) {
          this.tokenValues.selectedTerminalId = this.availableTerminals[0].id
        }

        const bothTerminals = terminalArr.filter(terminal => {
          if (terminal.type && terminal.type[0] === '[') {
            return JSON.parse(terminal.type).some(item => item === 'ach') && JSON.parse(terminal.type).some(item => item !== 'ach')
          }
          return false
        })

        this.achTerminals = [...terminalArr.filter(terminal => {
          if (terminal.type === 'ach') return true
          if (terminal.type && terminal.type[0] === '[') return !JSON.parse(terminal.type).some(item => item !== 'ach')
          return false
        }), ...bothTerminals]

        this.cardTerminals = [...terminalArr.filter(terminal => {
          if (terminal.type && terminal.type[0] === '[') return !JSON.parse(terminal.type).some(item => item === 'ach')
          return terminal.type !== 'ach'
        }), ...bothTerminals]

        if (!bothTerminals.length) {
          this.useTwoTerminals = true
        } else if ((this.achTerminals.length - bothTerminals.length) > 0 || (this.cardTerminals.length - bothTerminals.length) > 0) {
          this.showCheckbox = true
        }

        if (bothTerminals.length === 1 && !this.useTwoTerminals) {
          this.tokenValues.selectedTerminalId = bothTerminals[0].id
        }
      } catch (err) {
        console.error(err)
      } finally {
        this.hppLoadingTerminals = false
      }
    },

    async regenerateURL () {
      this.terminalError = ''
      if (!this.tokenValues.selectedTerminalId && !this.tokenValues.selectedACHTerminalId && !this.tokenValues.selectedCardTerminalId) {
        this.terminalError = 'At least one terminal is required.'
        return
      }
      if (!confirm('Are you sure you want to regenerate the link? The existing link will be deactivated.')) return

      this.generatedUrl = ''
      this.generatedUrlError = ''

      const terminalId = !this.useTwoTerminals
        ? this.tokenValues.selectedTerminalId
        : { ach: this.tokenValues.selectedACHTerminalId, card: this.tokenValues.selectedCardTerminalId }

      if (!this.tokenValues.selectedTerminalId && !this.tokenValues.selectedACHTerminalId && !this.tokenValues.selectedCardTerminalId) {
        return
      }

      try {
        let regenerateData = {
          accountId: this.hasPermission('superuser') ? this.hppSelectedAccountId : this.accountSelected.account_id,
          terminalId
        }

        if (this.consentEnabled) {
          regenerateData.custom = {
            consent: {
              enabled: true,
              required: this.consentRequired,
              label: this.consentLabel || 'I agree to the Terms and Conditions of this payment.'
            }
          }
          if (this.consentModalEnabled) {
            regenerateData.custom.consent.modal = {
              enabled: true,
              title: this.consentModalTitle || 'Terms and Conditions',
              content: this.consentModalContent || ''
            }
          }
        }

        if (this.restrictPaymentTypes) {
          const paymentTypesAllowed = []
          if (this.allowCard && this.terminalSupportsCard) paymentTypesAllowed.push('card')
          if (this.allowACH && this.terminalSupportsACH) paymentTypesAllowed.push('ach')
          if (paymentTypesAllowed.length) {
            if (!regenerateData.custom) regenerateData.custom = {}
            regenerateData.custom.paymentTypesAllowed = paymentTypesAllowed
          }
        }

        let { data } = await this.api({
          method: 'post',
          url: '/hosted_payment/regenerate',
          data: regenerateData
        })

        if (!data.error) {
          this.generatedToken = data.token
          this.generatedUrl = `https://payments${process.env.NODE_ENV === 'development' ? '-dev' : window.location.hostname.includes('-qa.') ? '-qa' : ''}.paynetworx.com?token=${data.token}`
        } else {
          this.generatedUrlError = 'An error has occurred. Please relog and try again.'
        }
      } catch (err) {
        this.generatedUrlError = 'An error has occurred. Please relog and try again.'
        console.error(err)
      }
    },

    async updateURL () {
      if (!this.generatedToken) return

      this.generatedUrlError = ''

      const custom = {}

      if (this.consentEnabled) {
        custom.consent = {
          enabled: true,
          required: this.consentRequired,
          label: this.consentLabel || 'I agree to the Terms and Conditions of this payment.'
        }
        if (this.consentModalEnabled) {
          custom.consent.modal = {
            enabled: true,
            title: this.consentModalTitle || 'Terms and Conditions',
            content: this.consentModalContent || ''
          }
        }
      } else {
        custom.consent = { enabled: false }
      }

      if (this.restrictPaymentTypes) {
        const paymentTypesAllowed = []
        if (this.allowCard && this.terminalSupportsCard) paymentTypesAllowed.push('card')
        if (this.allowACH && this.terminalSupportsACH) paymentTypesAllowed.push('ach')
        custom.paymentTypesAllowed = paymentTypesAllowed.length ? paymentTypesAllowed : null
      } else {
        custom.paymentTypesAllowed = null
      }

      try {
        let { data } = await this.api({
          method: 'put',
          url: `/hosted_payment/${this.generatedToken}`,
          data: { custom }
        })

        if (!data.error) {
          this.generatedUrl = `https://payments${process.env.NODE_ENV === 'development' ? '-dev' : window.location.hostname.includes('-qa.') ? '-qa' : ''}.paynetworx.com?token=${this.generatedToken}`
        } else {
          this.generatedUrlError = 'An error has occurred updating the link. Please relog and try again.'
        }
      } catch (err) {
        this.generatedUrlError = 'An error has occurred updating the link. Please relog and try again.'
        console.error(err)
      }
    },

    async getURL () {
      this.terminalError = ''

      this.generatedUrl = ''
      this.generatedUrlError = ''

      if (this.availableTerminals.length === 1) {
        this.tokenValues.selectedTerminalId = this.availableTerminals[0].id
      }

      if (this.tokenValues.selectedTerminalId || this.tokenValues.selectedCardTerminalId || this.tokenValues.selectedACHTerminalId) {
        try {
          let tokenData = {
            accountId: this.hasPermission('superuser') ? this.hppSelectedAccountId : this.accountSelected.account_id,
            ...this.tokenValues,
            terminalId: !this.useTwoTerminals
              ? this.tokenValues.selectedTerminalId
              : { ach: this.tokenValues.selectedACHTerminalId, card: this.tokenValues.selectedCardTerminalId }
          }

          if (this.consentEnabled) {
            tokenData.custom = {
              consent: {
                enabled: true,
                required: this.consentRequired,
                label: this.consentLabel || 'I agree to the Terms and Conditions of this payment.'
              }
            }
            if (this.consentModalEnabled) {
              tokenData.custom.consent.modal = {
                enabled: true,
                title: this.consentModalTitle || 'Terms and Conditions',
                content: this.consentModalContent || ''
              }
            }
          }

          if (this.restrictPaymentTypes) {
            const paymentTypesAllowed = []
            if (this.allowCard && this.terminalSupportsCard) paymentTypesAllowed.push('card')
            if (this.allowACH && this.terminalSupportsACH) paymentTypesAllowed.push('ach')
            if (paymentTypesAllowed.length) {
              if (!tokenData.custom) tokenData.custom = {}
              tokenData.custom.paymentTypesAllowed = paymentTypesAllowed
            }
          }

          let { data } = await this.api({
            method: 'post',
            url: `/hosted_payment/tokenize`,
            data: tokenData
          })

          if (!data.error) {
            this.generatedToken = data.token
            this.generatedUrl = `https://payments${process.env.NODE_ENV === 'development' ? '-dev' : window.location.hostname.includes('-qa.') ? '-qa' : ''}.paynetworx.com?token=${data.token}`
          } else {
            console.log(data)
            this.generatedUrlError = 'An error has occurred. Please relog and try again.'
          }
        } catch (err) {
          this.generatedUrlError = 'An error has occurred. Please relog and try again.'

          console.error(err)
        }
      }
    }
  }
}
</script>
<style>
.v-input.terminal-select {
  height: 50px;
}
.v-input.double-terminal-select {
  height: 60px;
  font-size: 14px;
}
.v-card__title {
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #9b9b9b;
}
.v-btn--outline {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.26);
}
.table-align-right {
  text-align: right;
  padding-right: 24px;
}
.profile-header {
  display: grid;
  grid-template-columns: 1fr auto
}
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue